export default __webpack_public_path__ + "static/media/ecommerce-lg-2.20779df2.webp";